import axios from 'axios';

// Use proxy in development - it handles CORS and network issues
const getApiBaseUrl = () => {
  if (process.env.REACT_APP_API_URL) {
    console.log('[API] Using REACT_APP_API_URL:', process.env.REACT_APP_API_URL);
    return process.env.REACT_APP_API_URL;
  }
  // In development, use relative URL to leverage the proxy
  // The proxy in setupProxy.js will forward /api/* to the backend
  if (process.env.NODE_ENV === 'development') {
    console.log('[API] Development mode - using proxy at /api');
    return '/api';
  }
  // Production: use relative path since nginx will proxy /api to backend
  // This works when frontend is served through nginx on port 3000
  console.log('[API] Production mode - using nginx proxy at /api');
  return '/api';
};

const baseURL = getApiBaseUrl();
console.log('[API] Initialized with baseURL:', baseURL);
console.log('[API] NODE_ENV:', process.env.NODE_ENV);

const api = axios.create({
  baseURL: baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    console.log('[API] 📤 Request:', config.method?.toUpperCase(), config.url);
    console.log('[API] Full URL:', config.baseURL + config.url);
    return config;
  },
  (error) => {
    console.error('[API] Request setup error:', error);
    return Promise.reject(error);
  }
);

// Response interceptor to handle errors
api.interceptors.response.use(
  (response) => {
    console.log('[API] ✅ Response received:', response.config.method?.toUpperCase(), response.config.url, response.status);
    return response;
  },
  (error) => {
    console.error('[API] ❌ Error:', error.config?.method?.toUpperCase(), error.config?.url);
    
    if (error.response) {
      // Server responded with error status
      console.error('[API] Response status:', error.response.status);
      console.error('[API] Response data:', error.response.data);
      console.error('[API] Full URL:', error.config?.baseURL + error.config?.url);
    } else if (error.request) {
      // Request was made but no response received
      console.error('[API] No response received - Network Error');
      console.error('[API] Request URL:', error.config?.baseURL + error.config?.url);
      console.error('[API] Possible causes:');
      console.error('[API]   - Backend server is not running');
      console.error('[API]   - CORS is blocking the request');
      console.error('[API]   - Network connectivity issue');
      console.error('[API]   - Proxy not working (check setupProxy.js)');
    } else {
      // Error setting up the request
      console.error('[API] Request setup error:', error.message);
    }
    
    // Only log out on 401 if it's not a password error for evidence
    // Password errors for evidence will have specific error messages
    if (error.response?.status === 401) {
      const url = error.config?.url || '';
      // Don't log out for evidence password errors - these are expected
      if (url.includes('/evidence/') && (url.includes('/view') || url.includes('/download') || url.match(/\/evidence\/\d+$/))) {
        // This is an evidence password error, don't log out
        return Promise.reject(error);
      }
      // For other 401 errors, log out
      localStorage.removeItem('token');
      localStorage.removeItem('loginTimestamp');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
